import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { SEOFlowShellComponent } from './containers/seo-flow-shell/seo-flow-shell.component';

const routes: Routes = [
  {
    component: SEOFlowShellComponent,
    matcher: customURL,
  },
];

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function customURL(url: UrlSegment[]): any {
  const urlArray = url.map((seg) => seg.path);
  const strapiPrefix = urlArray[0];
  const pageType = urlArray[urlArray.length - 1];

  urlArray.pop();
  urlArray.shift();
  const strapiUID = urlArray
    .map((seg) => {
      return seg;
    })
    .join('_');
  return {
    consumed: url,
    posParams: {
      strapiUID: new UrlSegment(strapiUID, {}),
      strapiPrefix: new UrlSegment(strapiPrefix, {}),
      pageType: new UrlSegment(pageType, {}),
    },
  };
}

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SEOFlowRoutingModule {}
